import React from 'react';
import IaPhasedLoading from '../IaPhasedLoading';

export default function WizardStepPipeline({
  loading,
  jobPhase,
  engineLabel,
  error,
  jobId,
  onCancel,
}) {
  return (
    <div className="space-y-4 py-4">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-wider text-iron-accent">Gerando treinos</p>
        <p className="mt-1 text-xs text-iron-muted leading-relaxed">
          A IA está montando o pack com base no seu perfil. Pode levar até 1 minuto.
        </p>
        <p className="mt-2 rounded-lg border border-iron-info/35 bg-iron-info/10 px-3 py-2 text-xs text-iron-info leading-relaxed">
          Pode fechar este assistente — acompanhe o progresso na barra <strong>Motor IA</strong> no topo.
          Toque em <strong>Rever</strong> quando os treinos estiverem prontos.
        </p>
      </div>

      {loading && (
        <IaPhasedLoading
          phase={jobPhase}
          className="border border-iron-accent/35 rounded-xl p-4"
          hint="Motor IA a trabalhar no seu pack…"
        />
      )}

      {error && (
        <p className="rounded-lg border border-red-500/40 bg-red-500/10 px-3 py-2 font-mono text-xs text-red-300">
          {error}
        </p>
      )}

      {loading && jobId && (
        <button
          type="button"
          onClick={onCancel}
          className="font-mono text-[10px] uppercase tracking-wide text-iron-accent hover:underline"
        >
          Cancelar geração
        </button>
      )}
    </div>
  );
}
